import Pusher, { type Options } from 'pusher-js';

const DEFAULT_APP_KEY = import.meta.env.VITE_PUSHER_APP_KEY || '';
const DEFAULT_OPTIONS: Options = { cluster: 'sa1', enabledTransports: ['ws', 'wss'] };

const instances = new Map<string, Pusher>();

function instanceKey(appKey: string, options: Options): string {
  return `${appKey}|${JSON.stringify(options)}`;
}

export function getPusherClient(appKey: string = DEFAULT_APP_KEY, options: Options = DEFAULT_OPTIONS): Pusher {
  const key = instanceKey(appKey, options);
  let inst = instances.get(key);
  if (!inst) {
    inst = new Pusher(appKey, options);
    instances.set(key, inst);
  }
  return inst;
}

const channelRefCount = new Map<string, number>();

function channelKey(appKey: string, options: Options, channelName: string): string {
  return `${instanceKey(appKey, options)}::${channelName}`;
}

export function subscribeChannel(
  channelName: string,
  appKey: string = DEFAULT_APP_KEY,
  options: Options = DEFAULT_OPTIONS
) {
  const pusher = getPusherClient(appKey, options);
  const channel = pusher.subscribe(channelName);
  const cKey = channelKey(appKey, options, channelName);
  channelRefCount.set(cKey, (channelRefCount.get(cKey) || 0) + 1);

  return {
    channel,
    unsubscribe: () => {
      const next = (channelRefCount.get(cKey) || 1) - 1;
      if (next <= 0) {
        channelRefCount.delete(cKey);
        pusher.unsubscribe(channelName);
      } else {
        channelRefCount.set(cKey, next);
      }
    },
  };
}
